var map = {
	"./sb0.png": "RbhO",
	"./sb1.png": "cBnK"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "msT+";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/sb.*\.png$
// module id = msT+
// module chunks = 3